module.exports = __webpack_public_path__ + "img/slow_loader.28cecb98.svg";